// Models
import {
  CustomChecklistActionTypes,
  CustomChecklistUpdateItemPayload,
  CustomChecklistSearchPayload,
} from 'app/shared/customChecklist/models';

// Helpers
import { createAction, ActionsUnion } from 'app/shared/utils/action-helpers';

// Search custom checklist by tags and type
export const retrieveCustomChecklist = (
  payload: CustomChecklistSearchPayload,
) =>
  createAction(CustomChecklistActionTypes.RETRIEVE_CUSTOM_CHECKLIST, payload);

export const retrieveCustomChecklistSuccess = (result) =>
  createAction(
    CustomChecklistActionTypes.RETRIEVE_CUSTOM_CHECKLIST_SUCCESS,
    result,
  );

export const retrieveCustomChecklistSubmission = (id: number) =>
  createAction(
    CustomChecklistActionTypes.RETRIEVE_CUSTOM_CHECKLIST_SUBMISSION,
    id,
  );

export const retrieveCustomChecklistSubmissionSuccess = (result) =>
  createAction(
    CustomChecklistActionTypes.RETRIEVE_CUSTOM_CHECKLIST_SUBMISSION_SUCCESS,
    result,
  );

export const updateCustomChecklistItem = (
  payload: CustomChecklistUpdateItemPayload,
) =>
  createAction(
    CustomChecklistActionTypes.UPDATE_CUSTOM_CHECKLIST_ITEM,
    payload,
  );

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CustomChecklistActionsList = {
  retrieveCustomChecklist,
  retrieveCustomChecklistSuccess,
  retrieveCustomChecklistSubmission,
  retrieveCustomChecklistSubmissionSuccess,
  updateCustomChecklistItem,
};

export type CustomChecklistActions = ActionsUnion<
  typeof CustomChecklistActionsList
>;
